<template>
  <v-card class="mx-auto EK-card rounded-xl rounded-tl-0 IMThemeGray store-action-form">
    <v-card-text class="pt-3 text-right">
      <div>
        <label>الاسم</label>
        <v-text-field
          rounded
          dense
          solo
          readonly
          v-model="contactCustomerDto.userFirstName"
        ></v-text-field>
      </div>
      <div>
        <label>الكنية</label>
        <v-text-field
          rounded
          dense
          solo
          readonly
          v-model="contactCustomerDto.userLastName"
        ></v-text-field>
      </div>
      <div>
        <label>النص</label>
        <v-textarea
          color="secondary"
          id="description"
          rounded
          readonly
          solo
          v-model="contactCustomerDto.text"
        ></v-textarea>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        class="mx-auto px-8"
        @click="onConfirmDelete(contactCustomerDto.id, customersIndex)"
        rounded
      >
        حذف
        <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2" />
      </v-btn>
    </v-card-actions>
    <v-card-actions>
    <v-btn
        @click="isShowSMS()"
        dark
        color="IMThemeOrange"
        rounded
        class="rounded-tl-0 px-6 mx-auto"
      >
        إرسال رسالة SMS
      </v-btn>
     </v-card-actions>
    <v-dialog v-model="showSMS" width="1000px">
      <smsModal :Type="2" :Id="contactCustomerDto.userInfoId" @close="isShowSMS()" />
    </v-dialog>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import smsModal from "@/components/smsModal.vue";
export default {
  props: {
    customersIndex: String,
  },
  components:{
      smsModal
  },
  data: () => ({
    showSMS: false,
  }),
  created() {
    this.getCustomerDetails(this.customersIndex);
    this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
    setTimeout(() => {
      window.scrollTo(this.offset, this.offset);
    }, 100);
  },
  computed: {
    ...mapGetters(["contactCustomerDto"]),
  },
  methods: {
    getOffset(el) {
      var _x = 0;
      var _y = 0;
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
      }
      return { top: _y, left: _x };
    },
    ...mapActions(["deleteContactsCustomer", "getCustomerDetails"]),
    onConfirmDelete(id, index) {
      this.deleteContactsCustomer({ id, index });
    },
    isShowSMS() {
      this.showSMS = !this.showSMS;
    },
  },
  watch: {
    customersIndex(index) {
      this.getCustomerDetails(index);
      this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
      console.log(this.offset);
      setTimeout(() => {
        window.scrollTo(this.offset, this.offset);
      }, 100);
    },
  },
};
</script>
